import { format } from "date-fns";
import {
  FlightSummaryTimeMode,
  IFlightSummaryKpi,
  IFlightSummaryRequest,
  IFlightSummaryResponse,
} from "../../models/flights/IFlightSummary";
import { payloadDateFormat } from "../common/DateHelperFunctions";

export const buildFlightSummaryPayload = (
  airportCode: string,
  startDate: Date,
  endDate: Date,
  timeMode: FlightSummaryTimeMode,
  timezone: string
): IFlightSummaryRequest[] => [
  {
    airportCode,
    start: format(startDate, payloadDateFormat),
    end: format(endDate, payloadDateFormat),
    timeMode,
    tz: timezone,
  },
];

export const getFlightSummaryResult = (
  responses: IFlightSummaryResponse[] | undefined,
  airportCode: string
): IFlightSummaryKpi[] => {
  const normalizedAirportCode = airportCode.trim().toUpperCase();
  const response = responses?.find(
    (item) => item.airportCode.trim().toUpperCase() === normalizedAirportCode
  );

  return response && response.error == null ? response.result : [];
};
